import { createReducer } from '@reduxjs/toolkit';

import initialState from './dialogDetailSlips.initialState';
import { ACTION_TYPES } from './dialogDetailSlips.constant';

const handleOpen = (state, action) => {
  state.visible = true;
  state.payload = action.payload;
};

const handleClose = (state) => {
  state.visible = false;
  state.payload = null;
};

const handleReset = () => initialState;

const handleFetchStart = (state) => {
  state.loading = true;
};

const handleFetchError = (state) => {
  state.loading = false;
};

const handleFetchSuccess = (state, action) => {
  state.loading = false;
  state.data = action.payload;
};

const handleUpdateReferenceId = (state, action) => {
  state.reference_id = action.payload;
};

export default createReducer(initialState, {
  [ACTION_TYPES.SET.OPEN]: handleOpen,
  [ACTION_TYPES.SET.CLOSE]: handleClose,
  [ACTION_TYPES.RESET]: handleReset,
  [ACTION_TYPES.FETCH.START]: handleFetchStart,
  [ACTION_TYPES.FETCH.ERROR]: handleFetchError,
  [ACTION_TYPES.FETCH.SUCCESS]: handleFetchSuccess,
  [ACTION_TYPES.UPDATE.REFERENCE_ID]: handleUpdateReferenceId,
});
